import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  consumers: {
    agents: {},
    contacts: {}
  },
  avatars: {
    agents: {},
    contacts: {}
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
